import { Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name : 'TxnHistFilter',
    pure : false
})

export class TxnHistFilter implements PipeTransform{
    transform(transactions: any[], searchTerm : any): any{
        if (transactions==null || transactions==undefined){
            return null;
        }
        return transactions.filter(transaction=>{
            return (transaction.cust_code.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) ||
                   (transaction.cust_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) ||
                   (transaction.txn_no.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);

        });
    }
}


// WEBPACK FOOTER //
// ./src/filters/txnHistFilter.pipe.ts